import classNames from 'classnames';
import IconTile from '@alltrails/denali/components/IconTile';
import TableRow from '@alltrails/denali/components/TableRow';
import Place from '@alltrails/denali/icons/Place';
import type { CoordinatesResult } from '@alltrails/types/AlgoliaResults';
import styles from './styles/styles.module.scss';

type CoordinatesResultContentProps = {
  result: CoordinatesResult;
};

const CoordinatesResultContent = ({ result }: CoordinatesResultContentProps) => {
  const icon = <IconTile icon={{ Component: Place }} />;

  return (
    <TableRow
      className={classNames(styles.listItemContent, styles.noDescription)}
      leftContent={icon}
      label={
        <div className={styles.label}>
          {result.latitude}, {result.longitude}
        </div>
      }
      // TODO: ADV-335 replace the raw `type` ("coordinates") with a translated description
      description={result.type}
    />
  );
};

export default CoordinatesResultContent;
